module.exports = __webpack_public_path__ + "images/hunan_banner02.jpg?4e0b465b18f11e53b7417c883b73019b";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/hunan_banner02.jpg
// module id = 188
// module chunks = 1